import { createSelector } from "reselect"
import { findLast, get, chain } from "lodash"
import { getSelectedDate } from "modules/security-profile/selectors/dates"
import { isSameTradingDay } from "helpers/dates"
import { getFilteredData, getCategoryItems } from "./data"

export const getDetails = createSelector(
  [getFilteredData, getCategoryItems, getSelectedDate],
  (data, items, date) => {
    const datum = findLast(data, d => isSameTradingDay(d.date, date))

    return chain(items)
      .map(item => ({
        ...item,
        value: get(datum, item.id),
      }))
      .sortBy(({ value }) => -Math.abs(value))
      .value()
  },
)
